import RnFormError from './RnFormError';

export default class FormAlreadySubmittingError extends RnFormError {
    constructor(message = 'Already submitting form') {
        super(message);
    }
}
